module.exports = __webpack_public_path__ + "img/choco-shake-speciaux.17e454df.jpg";